<div *ngIf="hasItems" class="swiper-wrapper">
  <swiper [config]="config" (slideChange)="onSlideChange($event)">
    <ng-template
      swiperSlide
      *ngFor="let item of items"
      let-data
      data-dgat="profile-assignments-9fe"
    >
      <div
        class="course-card"
        [class.course-card--prev]="data.isPrev"
        [class.course-card--next]="data.isNext"
        [style.background-image]="getBackgroundImage(data, item.model.imageUrl)"
      >
        <div *ngIf="item.model?.providerSummary?.logo" class="full-width">
          <hr class="provider-logo-line" />
          <div class="logo-container">
            <img
              [src]="item.model?.providerSummary?.logo"
              class="provider-logo"
            />
          </div>
        </div>
        <p class="course-title">
          {{ item.title }}
        </p>
        <button
          *ngIf="!(data.isPrev || data.isNext)"
          class="learn-more-btn"
          df-button
          dfButtonType="ghost"
          df-button-small
          data-dgat="search-featured-carousel-a78"
          (click)="openDetails(item.model)"
        >
          <div class="l_flexbar gap-full-half">
            {{ 'Core_LearnMore' | translate }}
            <df-icon icon="chevron-right" size="small"></df-icon>
          </div>
        </button>
      </div>
    </ng-template>
  </swiper>
</div>
